// @arch:pure-engine
// shipApproval.js — guard do incidente PR #618 (2026-07-10): uma sessão de CHAT
// criada da home, com Auto-aprovar ligado, commitou, PUSHOU 2 branches e ABRIU UM
// PR no repo principal do usuário sem nenhuma aprovação humana.
//
// A LEI deste guard: em sessão de CHAT (superfície conversacional), comandos que
// PUBLICAM — git push, gh pr create/merge, gh repo create/delete, mexer em remotes —
// exigem aprovação EXPLÍCITA do usuário, não importa o permissionsMode ('ignore'/
// Auto-aprovar) nem um 'allow' do auto-review. Sessões de CODE mantêm o fluxo
// sancionado (#111: agente commita e abre PR sozinho — escolha do Pedro).
//
// Decisão PURA (extraída do spine): o agentLoop só aplica o veredito.

export const SHIP_COMMAND_RE = /\bgit\s+push\b|\bgh\s+pr\s+(create|merge)\b|\bgh\s+repo\s+(create|delete)\b|\bgit\s+remote\s+(add|set-url|remove|rm)\b/i;

/** True quando o tool call é um comando de PUBLICAÇÃO numa sessão de CHAT. */
export function isChatShipCommand({ sessionKind, name, args }) {
  if (sessionKind !== 'chat' || name !== 'run_command') return false;
  const cmd = typeof args?.command === 'string' ? args.command : '';
  return SHIP_COMMAND_RE.test(cmd);
}

/**
 * O gate de aprovação do loop, em UMA decisão:
 *   'ask'  → mostra o dialog de aprovação (requestApproval);
 *   'auto' → executa sem perguntar.
 * Semântica preservada do inline anterior: auto-review 'allow' auto-executa;
 * permissionsMode 'ask' + tool mutante pergunta. NOVO: chat-ship SEMPRE pergunta —
 * inclusive sobre um 'allow' do auto-review e sob permissionsMode 'ignore'.
 * @param {{ sessionKind?: string|null, permissionsMode?: string, reviewDecision?: string|null,
 *           name: string, args: any, isMutating: boolean }} p
 * @returns {'ask'|'auto'}
 */
export function decideApprovalGate({ sessionKind, permissionsMode, reviewDecision, name, args, isMutating }) {
  if (isChatShipCommand({ sessionKind, name, args })) return 'ask';
  if (reviewDecision === 'allow') return 'auto';
  if (!isMutating) return 'auto';                 // ferramenta de leitura nunca pergunta
  if (permissionsMode === 'ignore') return 'auto'; // Auto-aprovar: mutações auto-executam
  // fail-CLOSED (harness-audit 07-13): antes, QUALQUER modo != 'ask' caía em 'auto' — um typo
  // ou um modo desconhecido ('deny', undefined) auto-aprovava uma mutação. Agora 'ask' E todo
  // modo não-reconhecido pedem aprovação. Os 2 modos reais ('ask'/'ignore') ficam byte-idênticos.
  return 'ask';
}
